/**
 * AppLayout Component
 * Pattern C: single 240px Sidebar + content area for all authenticated routes.
 */
import { useState, useEffect } from 'react';
import { Outlet, useRouterState } from '@tanstack/react-router';
import { Sidebar } from '../Sidebar';
import { BurgerButton } from '../BurgerMenu';
import { GlobalSearchProvider } from '@/components/search';
import { ErrorBoundary } from '@/app/ErrorBoundary';
import styles from './AppLayout.module.css';

export function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const routerState = useRouterState();

  useEffect(() => {
    setSidebarOpen(false);
  }, [routerState.location.pathname]);

  const closeSidebar = () => setSidebarOpen(false);

  return (
    <div className={styles.container}>
      <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />

      {sidebarOpen && (
        <div
          className={styles.overlay}
          onClick={closeSidebar}
          aria-hidden="true"
        />
      )}

      <GlobalSearchProvider />
      <main className={styles.content}>
        <div className={styles.mobileHeader}>
          <BurgerButton
            isOpen={sidebarOpen}
            onClick={() => setSidebarOpen((o) => !o)}
          />
          <div className={styles.mobileWordmarkGroup}>
            <img src="/logo-icon.svg" alt="" className={styles.mobileLogoImg} aria-hidden="true" />
            <span className={styles.mobileWordmark}>SEMAPHORIC<span className={styles.mobileWordmarkPeriod}>.</span></span>
          </div>
        </div>

        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
        <footer className={styles.appAttribution}>
          {/* logo.dev free-tier attribution requirement; remove when we
              upgrade to the paid plan. */}
          Logos provided by{' '}
          <a
            href="https://logo.dev/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Logo.dev
          </a>
        </footer>
      </main>
    </div>
  );
}
